import { Pipe, PipeTransform } from '@angular/core';
import { ColorModeEnum } from '@qvs/core';

@Pipe({
  name: 'assetByColorMode',
  standalone: true,
  pure: false
})
export class AssetByColorModePipe implements PipeTransform {
  transform(assets: { light: string; dark: string }): string {
    const root = document.documentElement;
    if (root.getAttribute('data-theme') === ColorModeEnum.DARK) {
      return assets?.dark;
    } else {
      return assets?.light;
    }
  }
}
